/* ==========================================================================
   Veil Customisation Modal
   --------------------------------------------------------------------------
   Zero dependencies. Talks to the page only via:
     1. [data-veil-start-customisation]  -> opens the modal
     2. #veilCustomisationOverlay        -> the modal markup (see the .liquid)
     3. the site's Add to Cart form      -> where we write properties[...]

   TODO before going live:
     - Set VEIL_UPLOAD_ENDPOINT to your PHP upload route (same pattern as
       your VTO proxy: accepts multipart file, pushes to Shopify Files API,
       returns { success: true, url: "https://cdn.shopify.com/..." }).
   ========================================================================== */
(function () {
  'use strict';

  var VEIL_UPLOAD_ENDPOINT = 'https://api.kalkifashion.com/kalki-india-app/veil-image-upload.php';
  var MAX_EMOTICON_TOTAL = 20;
  var MAX_UPLOAD_MB = 2;
  var MAX_PERSONALISATION_TYPES = 2;

  var overlay = document.getElementById('veilCustomisationOverlay');
  if (!overlay) return;

  var modal = overlay.querySelector('.veil-modal');
  var tabs = overlay.querySelectorAll('.veil-modal__tab');
  var panels = overlay.querySelectorAll('.veil-modal__panel');
  var saveNextBtn = document.getElementById('veilSaveNext');
  var saveSubmitBtn = document.getElementById('veilSaveSubmit');
  var styleErrorEl = document.getElementById('veilStyleError');
  var personalisationErrorEl = document.getElementById('veilPersonalisationError');

  function showError(el, message) {
    if (!el) return;
    if (message) {
      el.textContent = message;
      el.classList.add('is-visible');
    } else {
      el.textContent = '';
      el.classList.remove('is-visible');
    }
  }

  /* ---------------------------------------------------------------------
     State
     ------------------------------------------------------------------- */
  var state = {
    style: { shape: '', length: '', border: '', butta: '', color: '' },
    personalisation: {
      types: [],
      mantraText: '', mantraFont: '',
      hashtagText: '', hashtagFont: '',
      groomNameText: '', groomNameFont: '',
      initialsText: '', initialsFont: '',
      logoImage: '',
      emoticons: [],      // ['EM3', 'EM11']
      placement: {}      // { Hashtag: 2, Names: 3 }
    }
  };

  // Save & Next stays disabled until every one of these has a value.
  var STYLE_REQUIRED_FIELDS = ['shape', 'length', 'border', 'butta', 'color'];
  var STYLE_FIELD_LABELS = {
    shape: 'shape', length: 'measurement', border: 'border',
    butta: 'butta embroidery', color: 'fabric color'
  };

  /* ---------------------------------------------------------------------
     Open / close
     ------------------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-veil-start-customisation]')) {
      e.preventDefault();
      openModal();
    }
  });

  function openModal() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeModal() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
    if (e.target.closest('#veilModalClose')) closeModal();
    if (e.target.closest('[data-action="cancel"]')) closeModal();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeModal();
  });

  /* ---------------------------------------------------------------------
     "How To" image popup — one shared overlay for all 6 buttons, each
     button supplies its own desktop/mobile image via data attributes
     (populated from this section's schema settings in the .liquid file).
     If a button's image isn't configured yet, clicking it is a no-op.
     ------------------------------------------------------------------- */
  var howtoOverlay = document.getElementById('veilHowtoOverlay');
  var howtoImage = document.getElementById('veilHowtoImage');
  var howtoMobileSource = document.getElementById('veilHowtoMobileSource');

  if (howtoOverlay && howtoImage && howtoMobileSource) {
    overlay.querySelectorAll('.veil-accordion__howto').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation(); // the accordion header guard already covers this too, but be explicit
        var desktop = btn.dataset.howtoDesktop;
        if (!desktop) return; // not configured in the section settings — nothing to show
        howtoImage.src = desktop;
        howtoMobileSource.srcset = btn.dataset.howtoMobile || desktop;
        howtoOverlay.classList.add('is-open');
        howtoOverlay.setAttribute('aria-hidden', 'false');
      });
    });

    var closeHowto = function () {
      howtoOverlay.classList.remove('is-open');
      howtoOverlay.setAttribute('aria-hidden', 'true');
    };
    howtoOverlay.addEventListener('click', function (e) {
      if (e.target === howtoOverlay || e.target.closest('#veilHowtoClose')) closeHowto();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && howtoOverlay.classList.contains('is-open')) closeHowto();
    });
  }

  /* ---------------------------------------------------------------------
     "Learn More" text popup — separate from the customisation modal,
     opened straight from the trigger card (works even before the
     customisation modal has ever been opened).
     ------------------------------------------------------------------- */
  var learnMoreBtn = document.getElementById('veilLearnMoreBtn');
  var learnMoreOverlay = document.getElementById('veilLearnMoreOverlay');

  if (learnMoreBtn && learnMoreOverlay) {
    var closeLearnMore = function () {
      learnMoreOverlay.classList.remove('is-open');
      learnMoreOverlay.setAttribute('aria-hidden', 'true');
    };
    learnMoreBtn.addEventListener('click', function () {
      learnMoreOverlay.classList.add('is-open');
      learnMoreOverlay.setAttribute('aria-hidden', 'false');
    });
    learnMoreOverlay.addEventListener('click', function (e) {
      if (e.target === learnMoreOverlay || e.target.closest('#veilLearnMoreClose')) closeLearnMore();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && learnMoreOverlay.classList.contains('is-open')) closeLearnMore();
    });
  }

  /* ---------------------------------------------------------------------
     Tabs
     ------------------------------------------------------------------- */
  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      if (tab.hasAttribute('disabled')) return;
      switchTab(tab.dataset.tab);
    });
  });

  function switchTab(name) {
    tabs.forEach(function (t) {
      var active = t.dataset.tab === name;
      t.classList.toggle('is-active', active);
      t.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    panels.forEach(function (p) {
      p.classList.toggle('is-active', p.dataset.panel === name);
    });
  }

  function unlockPersonalisationTab() {
    var tab = overlay.querySelector('.veil-modal__tab[data-tab="personalisation"]');
    tab.removeAttribute('disabled');
    tab.classList.remove('veil-modal__tab--disabled');
  }

  /* ---------------------------------------------------------------------
     Accordion (single-open — only a header click changes which
     section is open; selecting an option inside stays put)
     ------------------------------------------------------------------- */
  overlay.querySelectorAll('.veil-accordion__section').forEach(function (section) {
    var header = section.querySelector('.veil-accordion__header');
    if (!header) return;
    header.addEventListener('click', function (e) {
      if (e.target.closest('.veil-accordion__howto, .veil-accordion__delete')) return;
      var isOpen = section.classList.contains('is-open');
      section.parentElement.querySelectorAll('.veil-accordion__section').forEach(function (s) {
        s.classList.remove('is-open');
      });
      if (!isOpen) section.classList.add('is-open');
      validateStyle(); // whichever section is now open drives the button state
      validatePersonalisation();
    });
  });

  // The 5 Style sections in order — Save & Next steps through these one at
  // a time (data-section value is the same string as the field it holds).
  var styleAccordion = overlay.querySelector('.veil-accordion[data-accordion="style"]');
  var styleSections = Array.prototype.slice.call(styleAccordion.querySelectorAll('.veil-accordion__section'));

  function getOpenStyleSection() {
    return styleSections.filter(function (s) { return s.classList.contains('is-open'); })[0] || null;
  }

  /* ---------------------------------------------------------------------
     Generic single-select controls: option cards / pills / swatches
     data-field + data-value drive state.style[field] = value
     ------------------------------------------------------------------- */
  overlay.querySelectorAll('[data-panel="style"] [data-field]').forEach(function (el) {
    if (el.tagName === 'INPUT' || el.tagName === 'SELECT') return; // handled separately
    el.addEventListener('click', function () {
      var field = el.dataset.field;
      var value = el.dataset.value;
      var siblings = overlay.querySelectorAll('[data-field="' + field + '"]');
      siblings.forEach(function (s) { s.classList.remove('is-selected'); });
      el.classList.add('is-selected');
      state.style[field] = value;

      validateStyle();
      // Section stays open — the customer closes/opens sections only via
      // the header click above (or the Save & Next step below), selecting
      // an option no longer touches it by itself.
    });
  });

  function isStyleFieldFilled(field) {
    return !!state.style[field];
  }

  // Save & Next is a step wizard: on any section except the last, it only
  // needs THAT section's own field filled to advance. On the last section
  // (color) it acts as the final gate and requires all 5 fields — this
  // covers someone jumping around via the headers instead of stepping
  // through in order.
  function validateStyle() {
    var openSection = getOpenStyleSection();
    if (!openSection) { saveNextBtn.disabled = true; showError(styleErrorEl, ''); return; }
    var isLast = styleSections.indexOf(openSection) === styleSections.length - 1;
    var missing = isLast
      ? STYLE_REQUIRED_FIELDS.filter(function (f) { return !isStyleFieldFilled(f); })
      : (isStyleFieldFilled(openSection.dataset.section) ? [] : [openSection.dataset.section]);
    var ok = missing.length === 0;
    saveNextBtn.disabled = !ok;
    if (ok) {
      showError(styleErrorEl, '');
    } else {
      var labels = missing.map(function (f) { return STYLE_FIELD_LABELS[f] || f; });
      showError(styleErrorEl, 'Please select ' + labels.join(', ') + ' to continue.');
    }
  }

  saveNextBtn.addEventListener('click', function () {
    if (saveNextBtn.disabled) return;
    var openSection = getOpenStyleSection();
    if (!openSection) return;
    var idx = styleSections.indexOf(openSection);

    if (idx === styleSections.length - 1) {
      // Last section done and everything validated — hand off to Personalisation
      syncStyleProperties();
      unlockPersonalisationTab();
      switchTab('personalisation');
      return;
    }

    openSection.classList.remove('is-open');
    var nextSection = styleSections[idx + 1];
    if (nextSection) nextSection.classList.add('is-open');
    validateStyle();
  });


  /* ---------------------------------------------------------------------
     Personalisation: type toggles (multi-select, max 2)
     ------------------------------------------------------------------- */
  overlay.querySelectorAll('.veil-type-toggle').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var type = btn.dataset.type;
      var wasSelected = state.personalisation.types.indexOf(type) > -1;

      if (wasSelected) {
        // Deselecting via the toggle should end up identical to clicking
        // Delete on its block — fully clear state, not just hide the UI —
        // otherwise the old value can still get written to cart properties.
        var section = overlay.querySelector('[data-type-block="' + cssEscape(type) + '"]');
        if (section) deletePersonalisationType(type, section);
        return;
      }

      if (state.personalisation.types.length >= MAX_PERSONALISATION_TYPES) {
        showError(personalisationErrorEl, 'You can select up to ' + MAX_PERSONALISATION_TYPES + ' options only — remove one to add another.');
        return;
      }

      state.personalisation.types.push(type);
      btn.classList.add('is-selected');
      overlay.querySelectorAll('[data-type-block="' + cssEscape(type) + '"]').forEach(function (block) {
        block.classList.remove('is-hidden');
        block.classList.add('is-open'); // just revealed — start expanded
      });
      updateTypeToggleLock();
      updatePlacementDiagram();
      updateEmoticonSurcharge();
      rebuildPlacementFields();
      validatePersonalisation();
    });
  });

  function cssEscape(value) {
    return value.replace(/(["\\])/g, '\\$1');
  }

  // Grey out + disable whichever tiles aren't selected once the max is hit.
  function updateTypeToggleLock() {
    var atMax = state.personalisation.types.length >= MAX_PERSONALISATION_TYPES;
    overlay.querySelectorAll('.veil-type-toggle').forEach(function (btn) {
      btn.classList.toggle('is-locked', atMax && !btn.classList.contains('is-selected'));
    });
  }

  // Reset a type's own state fields back to blank.
  function clearPersonalisationTypeState(type) {
    var p = state.personalisation;
    switch (type) {
      case 'Mantras': p.mantraText = ''; p.mantraFont = ''; break;
      case 'Hashtag': p.hashtagText = ''; p.hashtagFont = ''; break;
      case 'Names': p.groomNameText = ''; p.groomNameFont = ''; break;
      case 'Initials': p.initialsText = ''; p.initialsFont = ''; break;
      case 'Logo': p.logoImage = ''; break;
      case 'Emoticons': p.emoticons = []; break;
    }
    delete p.placement[type];
  }

  // "Delete" on a field-block: clears its state, resets its inputs, unchecks
  // its toggle tile above, and hides the block again — same end state as if
  // the type had never been selected.
  function deletePersonalisationType(type, section) {
    clearPersonalisationTypeState(type);

    section.querySelectorAll('input[type="text"], select').forEach(function (el) { el.value = ''; });
    section.querySelectorAll('input[type="file"]').forEach(function (el) { el.value = ''; });
    section.querySelectorAll('[data-preview]').forEach(function (el) { el.textContent = ''; el.classList.remove('is-error'); });
    section.querySelectorAll('[data-char-count-for]').forEach(function (el) {
      var max = el.textContent.split('/')[1] || '25';
      el.textContent = '0/' + max;
    });
    section.querySelectorAll('.veil-emoticon__checkbox').forEach(function (el) { el.checked = false; });
    refreshEmoticonUI();

    var idx = state.personalisation.types.indexOf(type);
    if (idx > -1) state.personalisation.types.splice(idx, 1);
    var toggleBtn = overlay.querySelector('.veil-type-toggle[data-type="' + cssEscape(type) + '"]');
    if (toggleBtn) toggleBtn.classList.remove('is-selected');
    section.classList.add('is-hidden');
    section.classList.remove('is-open');

    updateTypeToggleLock();
    updatePlacementDiagram();
    updateEmoticonSurcharge();
    rebuildPlacementFields();
    validatePersonalisation();
  }

  overlay.querySelectorAll('[data-delete-type]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var section = btn.closest('.veil-accordion__section');
      if (section) deletePersonalisationType(btn.dataset.deleteType, section);
    });
  });

  // For a selected type, is its own required field actually filled?
  // Text/image fields are OR'd (either one satisfies it) except Logo
  // and Emoticons, which only have one possible input.
  function isPersonalisationTypeFilled(type) {
    var p = state.personalisation;
    switch (type) {
      case 'Mantras': return !!p.mantraText && !!p.mantraFont;
      case 'Hashtag': return !!p.hashtagText && !!p.hashtagFont;
      case 'Names': return !!p.groomNameText && !!p.groomNameFont;
      case 'Initials': return !!p.initialsText && !!p.initialsFont;
      case 'Logo': return !!p.logoImage;
      case 'Emoticons': return p.emoticons.length > 0;
      default: return true;
    }
  }

  // Every selected type that's eligible for placement (Mantras/Hashtag/
  // Names/Logo) must have a placement position assigned.
  function isPlacementComplete() {
    var selected = state.personalisation.types.filter(function (t) {
      return PLACEMENT_ELIGIBLE_TYPES.indexOf(t) > -1;
    });
    return selected.every(function (t) { return !!state.personalisation.placement[t]; });
  }

  // Personalisation accordion sections, in DOM order, skipping whichever
  // conditional field-blocks aren't currently visible (their type isn't
  // selected). This list changes as types get toggled on/off, so it's
  // computed fresh each time rather than cached.
  function getVisiblePersonalisationSections() {
    var panel = overlay.querySelector('.veil-modal__panel[data-panel="personalisation"]');
    return Array.prototype.slice.call(panel.querySelectorAll('.veil-accordion__section')).filter(function (s) {
      return !s.classList.contains('is-hidden');
    });
  }

  function getOpenPersonalisationSection() {
    return getVisiblePersonalisationSections().filter(function (s) { return s.classList.contains('is-open'); })[0] || null;
  }

  var PERSONALISATION_SECTION_LABELS = {
    types: 'at least one option above (Mantras, Hashtag, Names...)',
    mantra: 'mantra text and font', hashtag: 'hashtag text and font',
    names: 'groom name text and font', initials: 'initials text and font',
    logo: 'a logo image', emoticons: 'at least one emoticon',
    placement: 'a placement position for each selected item'
  };
  var PERSONALISATION_TYPE_LABELS = {
    'Mantras': 'mantra', 'Hashtag': 'hashtag', 'Names': 'groom name',
    'Initials': 'initials', 'Logo': 'logo image', 'Emoticons': 'emoticon selection'
  };

  function isPersonalisationSectionFilled(section) {
    switch (section.dataset.section) {
      case 'types': return state.personalisation.types.length > 0;
      case 'mantra': return isPersonalisationTypeFilled('Mantras');
      case 'hashtag': return isPersonalisationTypeFilled('Hashtag');
      case 'names': return isPersonalisationTypeFilled('Names');
      case 'initials': return isPersonalisationTypeFilled('Initials');
      case 'logo': return isPersonalisationTypeFilled('Logo');
      case 'emoticons': return isPersonalisationTypeFilled('Emoticons');
      case 'placement': return isPlacementComplete();
      default: return true;
    }
  }

  // Same step-wizard shape as validateStyle(): the currently open section
  // gates Save & Submit on its own requirement, except the last visible
  // section, which re-checks everything (covers jumping around via headers
  // instead of stepping through in order).
  function validatePersonalisation() {
    var visible = getVisiblePersonalisationSections();
    var openSection = getOpenPersonalisationSection();
    if (!openSection) { saveSubmitBtn.disabled = true; showError(personalisationErrorEl, ''); return; }
    var isLast = visible.indexOf(openSection) === visible.length - 1;
    var missing = [];

    if (isLast) {
      if (state.personalisation.types.length === 0) {
        missing.push(PERSONALISATION_SECTION_LABELS.types);
      }
      state.personalisation.types.forEach(function (t) {
        if (!isPersonalisationTypeFilled(t)) missing.push(PERSONALISATION_TYPE_LABELS[t] || t);
      });
      if (!isPlacementComplete()) missing.push('placement position for each selected item');
    } else if (!isPersonalisationSectionFilled(openSection)) {
      missing.push(PERSONALISATION_SECTION_LABELS[openSection.dataset.section] || 'this field');
    }

    var ok = missing.length === 0;
    saveSubmitBtn.disabled = !ok;
    showError(personalisationErrorEl, ok ? '' : 'Please add ' + missing.join(', ') + ' to continue.');
  }

  /* ---------------------------------------------------------------------
     Text / font inputs -> state (delegated, so nothing depends on binding
     order or a stale element reference — works for any current or future
     field under the Personalisation panel)
     ------------------------------------------------------------------- */
  overlay.addEventListener('input', function (e) {
    var el = e.target.closest('[data-panel="personalisation"] [data-field]');
    if (!el) return;
    state.personalisation[el.dataset.field] = el.value;
    var counter = overlay.querySelector('[data-char-count-for="' + el.dataset.field + '"]');
    if (counter) counter.textContent = el.value.length + '/' + (el.maxLength > 0 ? el.maxLength : 25);
    validatePersonalisation();
  });
  overlay.addEventListener('change', function (e) {
    var el = e.target.closest('[data-panel="personalisation"] [data-field]');
    if (!el) return;
    state.personalisation[el.dataset.field] = el.value;
    validatePersonalisation();
  });

  /* ---------------------------------------------------------------------
     Single-file uploads (mantra/hashtag/groom name/initials/logo/custom design)
     ------------------------------------------------------------------- */
  overlay.querySelectorAll('[data-upload]').forEach(function (input) {
    input.addEventListener('change', function () {
      var file = input.files[0];
      if (!file) return;
      var key = input.dataset.upload;
      var preview = overlay.querySelector('[data-preview="' + key + '"]');
      if (file.size > MAX_UPLOAD_MB * 1024 * 1024) {
        if (preview) { preview.textContent = 'File too large — max ' + MAX_UPLOAD_MB + 'MB'; preview.classList.add('is-error'); }
        input.value = '';
        return;
      }
      if (preview) { preview.textContent = 'Uploading ' + file.name + '…'; preview.classList.remove('is-error'); }
      uploadFile(file).then(function (url) {
        state.personalisation[key] = url;
        if (preview) { preview.textContent = file.name + ' — uploaded'; preview.classList.remove('is-error'); }
        validatePersonalisation();
      }).catch(function () {
        if (preview) { preview.textContent = 'Upload failed, try again'; preview.classList.add('is-error'); }
      });
    });
  });

  overlay.querySelectorAll('.veil-dropzone').forEach(function (zone) {
    zone.addEventListener('dragover', function (e) { e.preventDefault(); zone.classList.add('is-dragover'); });
    zone.addEventListener('dragleave', function () { zone.classList.remove('is-dragover'); });
    zone.addEventListener('drop', function (e) {
      e.preventDefault();
      zone.classList.remove('is-dragover');
      var input = zone.querySelector('input[type="file"]');
      if (input && e.dataTransfer.files.length) {
        input.files = e.dataTransfer.files;
        input.dispatchEvent(new Event('change'));
      }
    });
  });

  /* ---------------------------------------------------------------------
     Emoticon grid ordering — done here, not in Liquid. Liquid's `sort`
     filter on metaobject values proved unreliable for this field in
     testing (returned unsorted / silently no-op rather than throwing),
     so each tile carries its sort_order as a data attribute and we just
     reorder the actual DOM nodes once, on load.
     ------------------------------------------------------------------- */
  (function sortEmoticonGrid() {
    var grid = overlay.querySelector('.veil-emoticon-grid');
    if (!grid) return;
    var tiles = Array.prototype.slice.call(grid.querySelectorAll('.veil-emoticon'));
    tiles.sort(function (a, b) {
      var aOrder = a.dataset.sortOrder || '';
      var bOrder = b.dataset.sortOrder || '';
      // numeric compare when both sides parse as numbers (handles "1" vs
      // "01" vs "10" the same way), falls back to plain text compare
      var aNum = parseFloat(aOrder), bNum = parseFloat(bOrder);
      if (!isNaN(aNum) && !isNaN(bNum) && aNum !== bNum) return aNum - bNum;
      return aOrder.localeCompare(bOrder);
    });
    tiles.forEach(function (tile) { grid.appendChild(tile); });
  })();

  /* ---------------------------------------------------------------------
     Emoticon checkboxes — pick up to MAX_EMOTICON_TOTAL distinct designs
     ------------------------------------------------------------------- */
  var emoticonCountEl = document.getElementById('veilEmoticonCount');
  overlay.querySelectorAll('.veil-emoticon__checkbox').forEach(function (checkbox) {
    checkbox.addEventListener('change', function () {
      var id = checkbox.value;
      var idx = state.personalisation.emoticons.indexOf(id);
      if (checkbox.checked) {
        if (idx === -1) {
          if (state.personalisation.emoticons.length >= MAX_EMOTICON_TOTAL) {
            checkbox.checked = false;
            showError(personalisationErrorEl, 'You can select up to ' + MAX_EMOTICON_TOTAL + ' emoticon designs only.');
            return;
          }
          state.personalisation.emoticons.push(id);
        }
      } else if (idx > -1) {
        state.personalisation.emoticons.splice(idx, 1);
      }
      refreshEmoticonUI();
      validatePersonalisation();
    });
  });

  function refreshEmoticonUI() {
    var total = state.personalisation.emoticons.length;
    emoticonCountEl.textContent = '[' + String(total).padStart(2, '0') + '/' + MAX_EMOTICON_TOTAL + ']';
    var atCap = total >= MAX_EMOTICON_TOTAL;
    overlay.querySelectorAll('.veil-emoticon__checkbox').forEach(function (checkbox) {
      checkbox.disabled = atCap && !checkbox.checked;
    });
  }

  /* ---------------------------------------------------------------------
     Add Placement — rebuilt whenever selected types change
     ------------------------------------------------------------------- */
  var PLACEMENT_ELIGIBLE_TYPES = ['Mantras', 'Hashtag', 'Names', 'Logo', 'Initials', 'Emoticons'];
  var PLACEMENT_POSITION_COUNT = 4; // base spot count; +1 (reserved for Emoticons) when Emoticons is selected
  var placementFieldsWrap = document.getElementById('veilPlacementFields');
  var placementMarkersWrap = document.getElementById('veilPlacementMarkers');

  // Swap which placement diagram image is shown based on whether
  // "Emoticons" is one of the selected types.
  function updatePlacementDiagram() {
    var showEmoticons = state.personalisation.types.indexOf('Emoticons') > -1;
    overlay.querySelectorAll('.veil-placement__diagram-img').forEach(function (img) {
      var isEmoticonsImg = img.dataset.diagramFor === 'emoticons';
      img.classList.toggle('is-hidden', isEmoticonsImg !== showEmoticons);
    });
  }

  function rebuildPlacementFields() {
    var selected = state.personalisation.types.filter(function (t) {
      return PLACEMENT_ELIGIBLE_TYPES.indexOf(t) > -1;
    });

    // drop placement values for types no longer selected
    Object.keys(state.personalisation.placement).forEach(function (t) {
      if (selected.indexOf(t) === -1) delete state.personalisation.placement[t];
    });

    placementFieldsWrap.innerHTML = '';
    if (!selected.length) {
      placementFieldsWrap.innerHTML = '<p class="veil-placement__empty">Select at least one item above to set its placement.</p>';
      placementMarkersWrap.innerHTML = '';
      return;
    }

    var emoticonsSelected = selected.indexOf('Emoticons') > -1;
    var positionCount = emoticonsSelected ? PLACEMENT_POSITION_COUNT + 1 : PLACEMENT_POSITION_COUNT;

    // Emoticons always takes the last position automatically — nothing
    // for the customer to choose there.
    if (emoticonsSelected) state.personalisation.placement['Emoticons'] = positionCount;

    selected.forEach(function (type) {
      var row = document.createElement('div');
      row.className = 'veil-placement__field';

      var label = document.createElement('label');
      label.textContent = type;

      var select = document.createElement('select');

      if (type === 'Emoticons') {
        var fixedOpt = document.createElement('option');
        fixedOpt.value = positionCount;
        fixedOpt.textContent = positionCount;
        fixedOpt.selected = true;
        select.appendChild(fixedOpt);
        select.disabled = true;
      } else {
        var blank = document.createElement('option');
        blank.value = '';
        blank.textContent = '–';
        select.appendChild(blank);
        for (var i = 1; i <= positionCount; i++) {
          var opt = document.createElement('option');
          opt.value = i;
          opt.textContent = i;
          if (emoticonsSelected && i === positionCount) opt.disabled = true; // reserved for Emoticons
          if (state.personalisation.placement[type] === i) opt.selected = true;
          select.appendChild(opt);
        }
        select.addEventListener('change', function () {
          var val = select.value ? parseInt(select.value, 10) : null;
          if (val) state.personalisation.placement[type] = val;
          else delete state.personalisation.placement[type];
          updatePlacementMarkers(selected, positionCount);
          validatePersonalisation();
        });
      }

      row.appendChild(label);
      row.appendChild(select);
      placementFieldsWrap.appendChild(row);
    });

    updatePlacementMarkers(selected, positionCount);
  }

  function updatePlacementMarkers(selected, positionCount) {
    placementMarkersWrap.innerHTML = '';
    selected.forEach(function (type) {
      var pos = state.personalisation.placement[type];
      if (!pos) return;
      var marker = document.createElement('span');
      marker.className = 'veil-placement__marker';
      marker.textContent = pos;
      // even vertical spread down the veil diagram across all fixed spots
      marker.style.top = (12 + (pos - 1) * (70 / (positionCount - 1))) + '%';
      placementMarkersWrap.appendChild(marker);
    });
  }

  /* ---------------------------------------------------------------------
     Upload helper — swap the endpoint/response shape for your PHP route
     ------------------------------------------------------------------- */
  function uploadFile(file) {
    var formData = new FormData();
    formData.append('file', file);
    formData.append('shop', overlay.dataset.shopDomain || '');
    return fetch(VEIL_UPLOAD_ENDPOINT, { method: 'POST', body: formData })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (!data || !data.success || !data.url) throw new Error('Upload failed');
        return data.url;
      });
  }

  /* ---------------------------------------------------------------------
     Property sync -> hidden inputs on the site's Add to Cart form(s)

     IMPORTANT: Kalki's product-form.js custom element always renames the
     variant id field from name="id" to name="items[0][id]" (to support
     the upsell/bundle add-to-cart flow), even on products with no upsell.
     That means new FormData(this.form) gets parsed by Shopify as a bulk
     items[] add, and a plain top-level properties[Key] field is silently
     ignored — it has to be items[0][properties][Key] instead. We write
     both names for every property so this keeps working even on a form
     that (on some other template/store) still uses the plain id/quantity/
     properties format.
     ------------------------------------------------------------------- */
  function getTargetForms() {
    var explicitSelector = overlay.dataset.productFormSelector;
    var forms = explicitSelector ? document.querySelectorAll(explicitSelector) : [];
    if (!forms.length) forms = document.querySelectorAll('form[action*="/cart/add"]');
    return Array.prototype.slice.call(forms);
  }

  /* ---------------------------------------------------------------------
     Emoticons price surcharge — this store already has server-side
     logic that reads properties[_extra_total] / items[0][properties]
     [_extra_total] and adjusts the line price accordingly (confirmed
     via an existing "Blouse Length" option elsewhere on the site). So
     this is just another property: set it when Emoticons is selected,
     clear it when it isn't. setProperty() already writes both the
     plain and items[0]-prefixed names, same as every other property.

     Also mirrors that same existing feature's approach to updating the
     on-page price display: both span patterns it uses
     ([data-pdp-product-price] and #aditional_costtotal /
     [js-pdp-original-price]) can appear more than once on the page, so
     every match gets updated, not just the first.
     ------------------------------------------------------------------- */
  var EMOTICON_SURCHARGE_AMOUNT = '50000'; // edit this to change the surcharge

  function formatInrPrice(amount) {
    return '₹' + Math.round(amount).toLocaleString('en-IN');
  }

  // Updates just the trailing price text inside an element, leaving any
  // nested label (e.g. the "MRP" span) untouched. Falls back to replacing
  // the whole textContent if there's no such nested element to preserve.
  function setTrailingPriceText(el, formattedPrice) {
    var lastNode = el.lastChild;
    if (el.children.length > 0 && lastNode && lastNode.nodeType === Node.TEXT_NODE) {
      lastNode.textContent = ' ' + formattedPrice;
    } else {
      el.textContent = formattedPrice;
    }
  }

  function updateDisplayedPrice(extra) {
    document.querySelectorAll('[data-pdp-product-price]').forEach(function (el) {
      var base = parseFloat((el.dataset.pdpProductPrice || '0').replace(/,/g, '')) || 0;
      setTrailingPriceText(el, formatInrPrice(base + extra));
    });

    document.querySelectorAll('#aditional_costtotal, [js-pdp-original-price]').forEach(function (el) {
      var rawBase = (el.dataset.price || el.textContent || '0').replace(/[^\d.]/g, '');
      var base = parseFloat(rawBase) || 0;
      setTrailingPriceText(el, formatInrPrice(base + extra));
    });
  }

  function updateEmoticonSurcharge() {
    var selected = state.personalisation.types.indexOf('Emoticons') > -1;
    var extra = selected ? parseFloat(EMOTICON_SURCHARGE_AMOUNT) : 0;

    getTargetForms().forEach(function (form) {
      setProperty(form, '_extra_total', selected ? EMOTICON_SURCHARGE_AMOUNT : '');
    });

    updateDisplayedPrice(extra);
  }

  function setSingleProperty(form, name, value) {
    var input = form.querySelector('input[name="' + name.replace(/"/g, '\\"') + '"]');
    if (!value) {
      if (input) input.remove();
      return;
    }
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  function setProperty(form, key, value) {
    setSingleProperty(form, 'properties[' + key + ']', value);
    setSingleProperty(form, 'items[0][properties][' + key + ']', value);
  }

  function syncStyleProperties() {
    var forms = getTargetForms();
    if (!forms.length) {
      console.warn('[veil-customisation] no form[action*="/cart/add"] found on the page — properties were not attached anywhere. Set data-product-form-selector on #veilCustomisationOverlay if your Add to Cart form has a different action, or check console for the form your theme actually submits.');
      return;
    }
    forms.forEach(function (form) {
      setProperty(form, 'Veil Shape', state.style.shape);
      setProperty(form, 'Veil Length', state.style.length);
      setProperty(form, 'Border Style', state.style.border);
      setProperty(form, 'Butta Embroidery', state.style.butta);
      setProperty(form, 'Fabric Color', state.style.color);
    });
    console.debug('[veil-customisation] style properties synced to ' + forms.length + ' form(s):', state.style);
  }

  function syncPersonalisationProperties() {
    var forms = getTargetForms();
    if (!forms.length) {
      console.warn('[veil-customisation] no form[action*="/cart/add"] found on the page — personalisation properties were not attached anywhere.');
      return;
    }
    var p = state.personalisation;
    function hasType(t) { return p.types.indexOf(t) > -1; }
    var emoticonSummary = p.emoticons.join(', ');
    var placementSummary = Object.keys(p.placement)
      .sort(function (a, b) { return p.placement[a] - p.placement[b]; })
      .map(function (type) { return p.placement[type] + ' ' + type; })
      .join(', ');

    forms.forEach(function (form) {
      setProperty(form, 'Personalisation Type', p.types.join(', '));

      // Every field below is guarded on its type still being selected —
      // belt-and-suspenders against stale state ever reaching the cart,
      // on top of deletePersonalisationType() clearing it at the source.
      setProperty(form, 'Mantra Text', hasType('Mantras') ? p.mantraText : '');
      setProperty(form, 'Mantra Font', hasType('Mantras') ? p.mantraFont : '');

      setProperty(form, 'Hashtag Text', hasType('Hashtag') ? p.hashtagText : '');
      setProperty(form, 'Hashtag Font', hasType('Hashtag') ? p.hashtagFont : '');

      setProperty(form, 'Groom Name Text', hasType('Names') ? p.groomNameText : '');
      setProperty(form, 'Groom Name Font', hasType('Names') ? p.groomNameFont : '');

      setProperty(form, 'Initials Text', hasType('Initials') ? p.initialsText : '');
      setProperty(form, 'Initials Font', hasType('Initials') ? p.initialsFont : '');

      setProperty(form, 'Logo Image', hasType('Logo') ? p.logoImage : '');
      setProperty(form, 'Emoticons Selected', hasType('Emoticons') ? emoticonSummary : '');
      setProperty(form, 'Placement Order', placementSummary);
    });
    console.debug('[veil-customisation] personalisation properties synced to ' + forms.length + ' form(s):', p);
  }

  saveSubmitBtn.addEventListener('click', function () {
    if (saveSubmitBtn.disabled) return;
    var visible = getVisiblePersonalisationSections();
    var openSection = getOpenPersonalisationSection();
    if (!openSection) return;
    var idx = visible.indexOf(openSection);

    if (idx === visible.length - 1) {
      // Last section done and everything validated — actually submit
      syncStyleProperties();
      syncPersonalisationProperties();
      closeModal();
      // Customer now uses the page's existing ADD TO CART / BUY NOW buttons.
      // If you'd rather add to cart immediately from here instead, swap this
      // for a fetch() POST to /cart/add.js using the same form's field values.
      return;
    }

    openSection.classList.remove('is-open');
    var nextSection = visible[idx + 1];
    if (nextSection) nextSection.classList.add('is-open');
    validatePersonalisation();
  });

  /* ---------------------------------------------------------------------
     Completeness check + navigating to whatever's missing
     ------------------------------------------------------------------- */
  function isStyleComplete() {
    return STYLE_REQUIRED_FIELDS.every(isStyleFieldFilled);
  }

  function isPersonalisationComplete() {
    if (state.personalisation.types.length === 0) return false;
    return state.personalisation.types.every(isPersonalisationTypeFilled) && isPlacementComplete();
  }

  function isCustomisationComplete() {
    return isStyleComplete() && isPersonalisationComplete();
  }

  // Opens the modal and jumps straight to the first tab + accordion
  // section that's still missing something, so the customer can see
  // exactly what to finish rather than hunting for it themselves.
  function openModalAtFirstIncomplete() {
    openModal();

    if (!isStyleComplete()) {
      switchTab('style');
      var firstIncompleteStyle = styleSections.filter(function (s) {
        return !isStyleFieldFilled(s.dataset.section);
      })[0];
      if (firstIncompleteStyle) {
        styleSections.forEach(function (s) { s.classList.remove('is-open'); });
        firstIncompleteStyle.classList.add('is-open');
      }
      validateStyle();
      return;
    }

    unlockPersonalisationTab();
    switchTab('personalisation');

    var visible = getVisiblePersonalisationSections();
    var target = state.personalisation.types.length === 0
      ? visible.filter(function (s) { return s.dataset.section === 'types'; })[0]
      : visible.filter(function (s) { return !isPersonalisationSectionFilled(s); })[0];
    if (target) {
      visible.forEach(function (s) { s.classList.remove('is-open'); });
      target.classList.add('is-open');
    }
    validatePersonalisation();
  }

  /* ---------------------------------------------------------------------
     Hard gate on the real Add to Cart: won't let the product be added
     until every veil customisation requirement is met. Capture phase so
     this runs before the theme's own submit/click handler (or GoKwik's
     buy-now popup handler). Covers a real <form> submit, a plain button
     click (Dawn's ATC button is name="add"), and GoKwik's own Buy Now
     button (a different element that doesn't submit the form itself, so
     it needs its own selector here — add more selectors to this same
     constant if there are other buy-now/express-checkout buttons on the
     page). Only ever active on pages where this modal is rendered (see
     the early `if (!overlay) return` at the top of this file) — other
     products are unaffected.

     Caveat: this can only block a popup if our capture-phase listener on
     document runs before whatever opens it. If GoKwik registers its own
     capture-phase listener earlier (script load order dependent), the
     popup could still slip through — if that happens in testing, the
     fix is either loading veil-customisation.js before GoKwik's script,
     or asking GoKwik support for a pre-open hook to call
     isCustomisationComplete() from instead.
     ------------------------------------------------------------------- */
  var ADD_TO_CART_TRIGGER_SELECTOR = '[name="add"], form[action*="/cart/add"] [type="submit"], .product-custom button.shopify-payment-button__button--unbranded';

  document.addEventListener('submit', function (e) {
    if (e.target && e.target.matches && e.target.matches('form[action*="/cart/add"]')) {
      if (!isCustomisationComplete()) {
        e.preventDefault();
        e.stopPropagation();
        openModalAtFirstIncomplete();
        return;
      }
      syncStyleProperties();
      syncPersonalisationProperties();
      updateEmoticonSurcharge();
    }
  }, true);

  document.addEventListener('click', function (e) {
    var btn = e.target.closest(ADD_TO_CART_TRIGGER_SELECTOR);
    if (btn) {
      if (!isCustomisationComplete()) {
        e.preventDefault();
        e.stopPropagation();
        openModalAtFirstIncomplete();
        return;
      }
      syncStyleProperties();
      syncPersonalisationProperties();
      updateEmoticonSurcharge();
    }
  }, true);

  // Set correct initial button/diagram/lock states rather than relying on the HTML defaults.
  updateTypeToggleLock();
  updatePlacementDiagram();
  updateEmoticonSurcharge();
  validateStyle();
  validatePersonalisation();

})();